import * as React from "react"
import Svg, {
  SvgProps,
  G,
  Path,
  Circle,
  Defs,
  ClipPath,
} from "react-native-svg"
const PickIcon = (props: SvgProps) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        fill="#000"
        d="M7.036 26.462c-.564 0-1.047-.201-1.45-.603a1.975 1.975 0 0 1-.602-1.449V7.57c0-.565.201-1.048.603-1.45a1.975 1.975 0 0 1 1.449-.602H18.19v1.23H7.036a.799.799 0 0 0-.59.231.799.799 0 0 0-.23.59V24.41c0 .24.076.436.23.59.154.154.35.23.59.23h16.84c.24 0 .437-.076.59-.23a.799.799 0 0 0 .231-.59V13.255h1.231V24.41c0 .564-.2 1.047-.603 1.449a1.975 1.975 0 0 1-1.448.602H7.036Zm16.102-15.508V8.308h-2.646V7.077h2.646V4.43h1.231v2.646h2.646v1.23H24.37v2.647h-1.23ZM9.61 21.938h11.898l-3.667-4.882-3.446 4.35-2.293-2.74-2.492 3.272Z"
        opacity={0.4}
      />
      <Circle
        cx={23.333}
        cy={8.667}
        r={9.167}
        fill="#C0A46F"
        stroke="#FDFBF9"
      />
      <Path
        fill="#FDFBF9"
        stroke="#C0A46F"
        strokeWidth={0.5}
        d="M22.704 9.296V12h1.258V9.296h2.705V8.038h-2.705V5.333h-1.258v2.705H20v1.258h2.704Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h32v32H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default PickIcon
